import React, { useMemo } from "react";
import { WSText } from "../core";
import { WSElement } from "../WSElement/WSElement.component";
import { WSList } from "../WSList/WSList.component";
import { OptionItem } from "./OptionItem";
import {
  FilterChangeHandler,
  WSFilterOption,
  WSFilterRadio,
  WSFilterSingleValue
} from "./types";

const DEFAULT_GROUP_NAME = "default";

type Props = {
  value?: WSFilterSingleValue;
  onChange: FilterChangeHandler;
} & Omit<WSFilterRadio, "type">;

export const FilterFieldRadio: React.FC<Props> = (props) => {
  const groups = useMemo(() => {
    const groups: Record<string, WSFilterOption<"radio">[]> = {};
    props.options.forEach((option) => {
      if (option.group) {
        if (!groups[option.group]) {
          groups[option.group] = [];
        }
        groups[option.group].push(option);
      } else {
        groups[DEFAULT_GROUP_NAME] = [
          ...(groups[DEFAULT_GROUP_NAME] || []),
          option
        ];
      }
    });
    return groups;
  }, [props.options]);

  const value = useMemo(
    () => (props.value ? props.value : props.options?.[0].name || ""),
    [props.options, props.value]
  );

  return (
    <WSList gap="XL">
      {Object.entries(groups).map(([group, options]) => {
        return (
          <WSElement key={group}>
            {DEFAULT_GROUP_NAME !== group && (
              <WSText.Caption mb="M" color="gray600" weight="medium">
                {group}
              </WSText.Caption>
            )}
            <WSList gap="XL">
              {options.map((option) => {
                return (
                  <OptionItem
                    key={option.name}
                    type="radio"
                    value={value === option.name}
                    onChange={() => {
                      props.onChange(props.name, option.name);
                    }}
                    {...option}
                    name={props.name}
                  />
                );
              })}
            </WSList>
          </WSElement>
        );
      })}
    </WSList>
  );
};
